import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPrimaryColor } from '../../selectors/configSelectors';

const ThemeColor = () => {
  const primaryColor = useSelector(state => getPrimaryColor(state));

  const updateThemeColor = () => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', `#${primaryColor}`);
  };

  useEffect(() => {
    updateThemeColor();
  }, []);

  return null;
};

export default ThemeColor;



// WEBPACK FOOTER //
// ./src/components/ThemeColor/theme_color.js